import { LinkExternal01 } from "@untitledui/icons";
import { HoverCard } from "../shared/HoverCard";

export const PlaybookDocsCard = () => {
  return (
    <a href="https://docs.light.dev" target="_blank" rel="noopener noreferrer">
      <HoverCard className="h-full">
        <div className="flex h-full w-full flex-col justify-between gap-6">
          <div className="flex flex-col gap-1">
            <p className="text-md leading-5 font-semibold text-primary">
              Developer documentation to help you build for electricity
            </p>
            <p className="text-md leading-5 text-secondary">
              Learn how to ship code with our public step-by-step dev guides.
            </p>
          </div>
          <div className="flex items-center gap-2">
            <span className="min-w-0 flex-1 font-mono text-xs text-tertiary">
              docs.light.dev
            </span>
            <LinkExternal01 className="size-5 shrink-0 text-tertiary" />
          </div>
        </div>
      </HoverCard>
    </a>
  );
};
